// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"addresses-list_wrapper__WtH78","title":"addresses-list_title__gPcuB","list":"addresses-list_list__12q_T"};